// Material
import { Alert as MuiAlert, CircularProgress } from '@mui/material'
import { styled } from '@mui/material/styles'
import { InfoOutlinedIcon } from '@weblite/icons'
// Common
import { ApproveIcon } from '$common/icons/approve'
import { ErrorMarkIcon } from '$common/icons'

const StyledMessage = styled(MuiAlert)`
  padding: 0;
  width: 100%;
  margin-top: 8px;
  background-color: transparent;
  align-items: center;

  color: ${({ theme, severity }) =>
    severity === 'error'
      ? theme.palette.error.main
      : severity === 'success'
        ? theme.palette.success.main
        : severity === 'info'
          ? theme.palette.primary700
          : theme.palette.neutral400};

  ${({ theme }) => ({ ...theme.typography.caption1 })};
  .MuiAlert-message {
    padding: 0;
    align-self: center;
  }

  .MuiAlert-icon {
    padding: 0;
    ${({ theme }) => ({ ...theme.typography.subtitle1 })};
    margin-left: 4px;
    align-self: start;
    margin-right: 0;
    color: inherit;
  }
`

interface Props {
  variant: 'success' | 'error' | 'info'
  text: string
  sxStyle?: Record<string, any>
}
export function Alert({ variant, text, sxStyle }: Props) {
  return (
    <StyledMessage
      severity={variant}
      iconMapping={{
        error: <ErrorMarkIcon fontSize="small" />,
        success: <ApproveIcon />,
        info: (
          <InfoOutlinedIcon fontSize="small" sx={{ color: 'primary700' }} />
        ),
      }}
      sx={sxStyle}
    >
      {text}
    </StyledMessage>
  )
}

Alert.defaultProps = {
  sxStyle: null,
}
